import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M16.9 22H7.1C5.4 22 4 20.61 4 18.9V5.1C4 3.4 5.39 2 7.1 2h9.8C18.6 2 20 3.39 20 5.1v13.8c0 1.71-1.39 3.1-3.1 3.1",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M20 8H4v5h16zM8 18.75c-.08 0-.16-.01-.24-.02-.08-.02-.16-.04-.24-.08a1.4 1.4 0 0 1-.21-.11c-.07-.05-.14-.1-.19-.16-.24-.23-.37-.55-.37-.88s.13-.65.37-.88c.05-.06.12-.11.19-.16.06-.04.14-.08.21-.11.08-.04.16-.06.24-.08.4-.08.83.06 1.12.35.24.23.37.55.37.88s-.13.65-.37.88c-.23.24-.55.37-.88.37M16 18.75c-.08 0-.16-.01-.24-.02-.08-.02-.16-.04-.24-.08a1.4 1.4 0 0 1-.21-.11c-.07-.05-.14-.1-.19-.16-.24-.23-.37-.55-.37-.88s.13-.65.37-.88c.05-.06.12-.11.19-.16.06-.04.14-.08.21-.11.08-.04.16-.06.24-.08.16-.03.32-.03.49 0 .07.02.15.04.23.08.07.03.15.07.21.11.07.05.14.1.19.16.24.23.37.55.37.88s-.13.65-.37.88c-.05.06-.12.11-.19.16-.06.04-.14.08-.21.11-.08.04-.16.06-.23.08-.09.01-.17.02-.25.02M14.5 5.75h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }